import _objectSpread from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/maximilian/Projekte/DevCloud/Apps/panel/node_modules/@babel/runtime/helpers/esm/createClass";

var LIB = function (t) {
  var e = {};

  function n(o) {
    if (e[o]) return e[o].exports;
    var r = e[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, o) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: o
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var o = Object.create(null);
    if (n.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) {
      n.d(o, r, function (e) {
        return t[e];
      }.bind(null, r));
    }
    return o;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 27);
}([function (t, e, n) {
  "use strict";

  var o = n(3),
      r = n(9),
      s = Object.prototype.toString;

  function i(t) {
    return "[object Array]" === s.call(t);
  }

  function a(t) {
    return null !== t && "object" == typeof t;
  }

  function c(t) {
    return "[object Function]" === s.call(t);
  }

  function u(t, e) {
    if (null != t) if ("object" != typeof t && (t = [t]), i(t)) for (var n = 0, o = t.length; n < o; n++) {
      e.call(null, t[n], n, t);
    } else for (var r in t) {
      Object.prototype.hasOwnProperty.call(t, r) && e.call(null, t[r], r, t);
    }
  }

  t.exports = {
    isArray: i,
    isArrayBuffer: function isArrayBuffer(t) {
      return "[object ArrayBuffer]" === s.call(t);
    },
    isBuffer: r,
    isFormData: function isFormData(t) {
      return "undefined" != typeof FormData && t instanceof FormData;
    },
    isArrayBufferView: function isArrayBufferView(t) {
      return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
    },
    isString: function isString(t) {
      return "string" == typeof t;
    },
    isNumber: function isNumber(t) {
      return "number" == typeof t;
    },
    isObject: a,
    isUndefined: function isUndefined(t) {
      return void 0 === t;
    },
    isDate: function isDate(t) {
      return "[object Date]" === s.call(t);
    },
    isFile: function isFile(t) {
      return "[object File]" === s.call(t);
    },
    isBlob: function isBlob(t) {
      return "[object Blob]" === s.call(t);
    },
    isFunction: c,
    isStream: function isStream(t) {
      return a(t) && c(t.pipe);
    },
    isURLSearchParams: function isURLSearchParams(t) {
      return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
    },
    isStandardBrowserEnv: function isStandardBrowserEnv() {
      return ("undefined" == typeof navigator || "ReactNative" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
    },
    forEach: u,
    merge: function t() {
      var e = {};

      function n(n, o) {
        "object" == typeof e[o] && "object" == typeof n ? e[o] = t(e[o], n) : e[o] = n;
      }

      for (var o = 0, r = arguments.length; o < r; o++) {
        u(arguments[o], n);
      }

      return e;
    },
    extend: function extend(t, e, n) {
      return u(e, function (e, r) {
        t[r] = n && "function" == typeof e ? o(e, n) : e;
      }), t;
    },
    trim: function trim(t) {
      return t.replace(/^\s*/, "").replace(/\s*$/, "");
    }
  };
}, function (t, e, n) {
  "use strict";

  (function (e) {
    var o = n(0),
        r = n(12),
        s = {
      "Content-Type": "application/x-www-form-urlencoded"
    };

    function i(t, e) {
      !o.isUndefined(t) && o.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
    }

    var a,
        c = {
      adapter: ("undefined" != typeof XMLHttpRequest ? a = n(4) : void 0 !== e && (a = n(4)), a),
      transformRequest: [function (t, e) {
        return r(e, "Content-Type"), o.isFormData(t) || o.isArrayBuffer(t) || o.isBuffer(t) || o.isStream(t) || o.isFile(t) || o.isBlob(t) ? t : o.isArrayBufferView(t) ? t.buffer : o.isURLSearchParams(t) ? (i(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : o.isObject(t) ? (i(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
      }],
      transformResponse: [function (t) {
        if ("string" == typeof t) try {
          t = JSON.parse(t);
        } catch (t) {}
        return t;
      }],
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      validateStatus: function validateStatus(t) {
        return t >= 200 && t < 300;
      }
    };
    c.headers = {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }, o.forEach(["delete", "get", "head"], function (t) {
      c.headers[t] = {};
    }), o.forEach(["post", "put", "patch"], function (t) {
      c.headers[t] = o.merge(s);
    }), t.exports = c;
  }).call(this, n(11));
}, function (t, e, n) {
  t.exports = n(8);
}, function (t, e, n) {
  "use strict";

  t.exports = function (t, e) {
    return function () {
      for (var n = new Array(arguments.length), o = 0; o < n.length; o++) {
        n[o] = arguments[o];
      }

      return t.apply(e, n);
    };
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0),
      r = n(13),
      s = n(15),
      i = n(16),
      a = n(17),
      c = n(5),
      u = "undefined" != typeof window && window.btoa && window.btoa.bind(window) || n(18);

  t.exports = function (t) {
    return new Promise(function (e, d) {
      var l = t.data,
          f = t.headers;
      o.isFormData(l) && delete f["Content-Type"];
      var p = new XMLHttpRequest(),
          h = "onreadystatechange",
          g = !1;

      if ("undefined" == typeof window || !window.XDomainRequest || "withCredentials" in p || a(t.url) || (p = new window.XDomainRequest(), h = "onload", g = !0, p.onprogress = function () {}, p.ontimeout = function () {}), t.auth) {
        var m = t.auth.username || "",
            w = t.auth.password || "";
        f.Authorization = "Basic " + u(m + ":" + w);
      }

      if (p.open(t.method.toUpperCase(), s(t.url, t.params, t.paramsSerializer), !0), p.timeout = t.timeout, p[h] = function () {
        if (p && (4 === p.readyState || g) && (0 !== p.status || p.responseURL && 0 === p.responseURL.indexOf("file:"))) {
          var n = "getAllResponseHeaders" in p ? i(p.getAllResponseHeaders()) : null,
              o = {
            data: t.responseType && "text" !== t.responseType ? p.response : p.responseText,
            status: 1223 === p.status ? 204 : p.status,
            statusText: 1223 === p.status ? "No Content" : p.statusText,
            headers: n,
            config: t,
            request: p
          };
          r(e, d, o), p = null;
        }
      }, p.onerror = function () {
        d(c("Network Error", t, null, p)), p = null;
      }, p.ontimeout = function () {
        d(c("timeout of " + t.timeout + "ms exceeded", t, "ECONNABORTED", p)), p = null;
      }, o.isStandardBrowserEnv()) {
        var y = n(19),
            P = (t.withCredentials || a(t.url)) && t.xsrfCookieName ? y.read(t.xsrfCookieName) : void 0;
        P && (f[t.xsrfHeaderName] = P);
      }

      if ("setRequestHeader" in p && o.forEach(f, function (t, e) {
        void 0 === l && "content-type" === e.toLowerCase() ? delete f[e] : p.setRequestHeader(e, t);
      }), t.withCredentials && (p.withCredentials = !0), t.responseType) try {
        p.responseType = t.responseType;
      } catch (e) {
        if ("json" !== t.responseType) throw e;
      }
      "function" == typeof t.onDownloadProgress && p.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && p.upload && p.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
        p && (p.abort(), d(t), p = null);
      }), void 0 === l && (l = null), p.send(l);
    });
  };
}, function (t, e, n) {
  "use strict";

  var o = n(14);

  t.exports = function (t, e, n, r, s) {
    var i = new Error(t);
    return o(i, e, n, r, s);
  };
}, function (t, e, n) {
  "use strict";

  t.exports = function (t) {
    return !(!t || !t.__CANCEL__);
  };
}, function (t, e, n) {
  "use strict";

  function o(t) {
    this.message = t;
  }

  o.prototype.toString = function () {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, o.prototype.__CANCEL__ = !0, t.exports = o;
}, function (t, e, n) {
  "use strict";

  var o = n(0),
      r = n(3),
      s = n(10),
      i = n(1);

  function a(t) {
    var e = new s(t),
        n = r(s.prototype.request, e);
    return o.extend(n, s.prototype, e), o.extend(n, e), n;
  }

  var c = a(i);
  c.Axios = s, c.create = function (t) {
    return a(o.merge(i, t));
  }, c.Cancel = n(7), c.CancelToken = n(25), c.isCancel = n(6), c.all = function (t) {
    return Promise.all(t);
  }, c.spread = n(26), t.exports = c, t.exports.default = c;
}, function (t, e) {
  function n(t) {
    return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
  }
  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */


  t.exports = function (t) {
    return null != t && (n(t) || function (t) {
      return "function" == typeof t.readFloatLE && "function" == typeof t.slice && n(t.slice(0, 0));
    }(t) || !!t._isBuffer);
  };
}, function (t, e, n) {
  "use strict";

  var o = n(1),
      r = n(0),
      s = n(20),
      i = n(21);

  function a(t) {
    this.defaults = t, this.interceptors = {
      request: new s(),
      response: new s()
    };
  }

  a.prototype.request = function (t) {
    "string" == typeof t && (t = r.merge({
      url: arguments[0]
    }, arguments[1])), (t = r.merge(o, {
      method: "get"
    }, this.defaults, t)).method = t.method.toLowerCase();
    var e = [i, void 0],
        n = Promise.resolve(t);

    for (this.interceptors.request.forEach(function (t) {
      e.unshift(t.fulfilled, t.rejected);
    }), this.interceptors.response.forEach(function (t) {
      e.push(t.fulfilled, t.rejected);
    }); e.length;) {
      n = n.then(e.shift(), e.shift());
    }

    return n;
  }, r.forEach(["delete", "get", "head", "options"], function (t) {
    a.prototype[t] = function (e, n) {
      return this.request(r.merge(n || {}, {
        method: t,
        url: e
      }));
    };
  }), r.forEach(["post", "put", "patch"], function (t) {
    a.prototype[t] = function (e, n, o) {
      return this.request(r.merge(o || {}, {
        method: t,
        url: e,
        data: n
      }));
    };
  }), t.exports = a;
}, function (t, e) {
  var n,
      o,
      r = t.exports = {};

  function s() {
    throw new Error("setTimeout has not been defined");
  }

  function i() {
    throw new Error("clearTimeout has not been defined");
  }

  function a(t) {
    if (n === setTimeout) return setTimeout(t, 0);
    if ((n === s || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

    try {
      return n(t, 0);
    } catch (e) {
      try {
        return n.call(null, t, 0);
      } catch (e) {
        return n.call(this, t, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : s;
    } catch (t) {
      n = s;
    }

    try {
      o = "function" == typeof clearTimeout ? clearTimeout : i;
    } catch (t) {
      o = i;
    }
  }();
  var c,
      u = [],
      d = !1,
      l = -1;

  function f() {
    d && c && (d = !1, c.length ? u = c.concat(u) : l = -1, u.length && p());
  }

  function p() {
    if (!d) {
      var t = a(f);
      d = !0;

      for (var e = u.length; e;) {
        for (c = u, u = []; ++l < e;) {
          c && c[l].run();
        }

        l = -1, e = u.length;
      }

      c = null, d = !1, function (t) {
        if (o === clearTimeout) return clearTimeout(t);
        if ((o === i || !o) && clearTimeout) return o = clearTimeout, clearTimeout(t);

        try {
          o(t);
        } catch (e) {
          try {
            return o.call(null, t);
          } catch (e) {
            return o.call(this, t);
          }
        }
      }(t);
    }
  }

  function h(t, e) {
    this.fun = t, this.array = e;
  }

  function g() {}

  r.nextTick = function (t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }
    u.push(new h(t, e)), 1 !== u.length || d || a(p);
  }, h.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = g, r.addListener = g, r.once = g, r.off = g, r.removeListener = g, r.removeAllListeners = g, r.emit = g, r.prependListener = g, r.prependOnceListener = g, r.listeners = function (t) {
    return [];
  }, r.binding = function (t) {
    throw new Error("process.binding is not supported");
  }, r.cwd = function () {
    return "/";
  }, r.chdir = function (t) {
    throw new Error("process.chdir is not supported");
  }, r.umask = function () {
    return 0;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);

  t.exports = function (t, e) {
    o.forEach(t, function (n, o) {
      o !== e && o.toUpperCase() === e.toUpperCase() && (t[e] = n, delete t[o]);
    });
  };
}, function (t, e, n) {
  "use strict";

  var o = n(5);

  t.exports = function (t, e, n) {
    var r = n.config.validateStatus;
    n.status && r && !r(n.status) ? e(o("Request failed with status code " + n.status, n.config, null, n.request, n)) : t(n);
  };
}, function (t, e, n) {
  "use strict";

  t.exports = function (t, e, n, o, r) {
    return t.config = e, n && (t.code = n), t.request = o, t.response = r, t;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);

  function r(t) {
    return encodeURIComponent(t).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }

  t.exports = function (t, e, n) {
    if (!e) return t;
    var s;
    if (n) s = n(e);else if (o.isURLSearchParams(e)) s = e.toString();else {
      var i = [];
      o.forEach(e, function (t, e) {
        null != t && (o.isArray(t) ? e += "[]" : t = [t], o.forEach(t, function (t) {
          o.isDate(t) ? t = t.toISOString() : o.isObject(t) && (t = JSON.stringify(t)), i.push(r(e) + "=" + r(t));
        }));
      }), s = i.join("&");
    }
    return s && (t += (-1 === t.indexOf("?") ? "?" : "&") + s), t;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0),
      r = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

  t.exports = function (t) {
    var e,
        n,
        s,
        i = {};
    return t ? (o.forEach(t.split("\n"), function (t) {
      if (s = t.indexOf(":"), e = o.trim(t.substr(0, s)).toLowerCase(), n = o.trim(t.substr(s + 1)), e) {
        if (i[e] && r.indexOf(e) >= 0) return;
        i[e] = "set-cookie" === e ? (i[e] ? i[e] : []).concat([n]) : i[e] ? i[e] + ", " + n : n;
      }
    }), i) : i;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);
  t.exports = o.isStandardBrowserEnv() ? function () {
    var t,
        e = /(msie|trident)/i.test(navigator.userAgent),
        n = document.createElement("a");

    function r(t) {
      var o = t;
      return e && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
      };
    }

    return t = r(window.location.href), function (e) {
      var n = o.isString(e) ? r(e) : e;
      return n.protocol === t.protocol && n.host === t.host;
    };
  }() : function () {
    return !0;
  };
}, function (t, e, n) {
  "use strict";

  var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  function r() {
    this.message = "String contains an invalid character";
  }

  r.prototype = new Error(), r.prototype.code = 5, r.prototype.name = "InvalidCharacterError", t.exports = function (t) {
    for (var e, n, s = String(t), i = "", a = 0, c = o; s.charAt(0 | a) || (c = "=", a % 1); i += c.charAt(63 & e >> 8 - a % 1 * 8)) {
      if ((n = s.charCodeAt(a += .75)) > 255) throw new r();
      e = e << 8 | n;
    }

    return i;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);
  t.exports = o.isStandardBrowserEnv() ? {
    write: function write(t, e, n, r, s, i) {
      var a = [];
      a.push(t + "=" + encodeURIComponent(e)), o.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), o.isString(r) && a.push("path=" + r), o.isString(s) && a.push("domain=" + s), !0 === i && a.push("secure"), document.cookie = a.join("; ");
    },
    read: function read(t) {
      var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove: function remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  } : {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);

  function r() {
    this.handlers = [];
  }

  r.prototype.use = function (t, e) {
    return this.handlers.push({
      fulfilled: t,
      rejected: e
    }), this.handlers.length - 1;
  }, r.prototype.eject = function (t) {
    this.handlers[t] && (this.handlers[t] = null);
  }, r.prototype.forEach = function (t) {
    o.forEach(this.handlers, function (e) {
      null !== e && t(e);
    });
  }, t.exports = r;
}, function (t, e, n) {
  "use strict";

  var o = n(0),
      r = n(22),
      s = n(6),
      i = n(1),
      a = n(23),
      c = n(24);

  function u(t) {
    t.cancelToken && t.cancelToken.throwIfRequested();
  }

  t.exports = function (t) {
    return u(t), t.baseURL && !a(t.url) && (t.url = c(t.baseURL, t.url)), t.headers = t.headers || {}, t.data = r(t.data, t.headers, t.transformRequest), t.headers = o.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers || {}), o.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
      delete t.headers[e];
    }), (t.adapter || i.adapter)(t).then(function (e) {
      return u(t), e.data = r(e.data, e.headers, t.transformResponse), e;
    }, function (e) {
      return s(e) || (u(t), e && e.response && (e.response.data = r(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
    });
  };
}, function (t, e, n) {
  "use strict";

  var o = n(0);

  t.exports = function (t, e, n) {
    return o.forEach(n, function (n) {
      t = n(t, e);
    }), t;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = function (t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  };
}, function (t, e, n) {
  "use strict";

  t.exports = function (t, e) {
    return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
  };
}, function (t, e, n) {
  "use strict";

  var o = n(7);

  function r(t) {
    if ("function" != typeof t) throw new TypeError("executor must be a function.");
    var e;
    this.promise = new Promise(function (t) {
      e = t;
    });
    var n = this;
    t(function (t) {
      n.reason || (n.reason = new o(t), e(n.reason));
    });
  }

  r.prototype.throwIfRequested = function () {
    if (this.reason) throw this.reason;
  }, r.source = function () {
    var t;
    return {
      token: new r(function (e) {
        t = e;
      }),
      cancel: t
    };
  }, t.exports = r;
}, function (t, e, n) {
  "use strict";

  t.exports = function (t) {
    return function (e) {
      return t.apply(null, e);
    };
  };
}, function (t, e, n) {
  "use strict";

  function o(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    this.name = "serverError", this.code = t, this.errors = e, this.message = n;
  }

  function r() {
    this.code = "unknownError", this.errors = [], this.name = "unknownConnectionError";
  }

  n.r(e);
  var s = n(2),
      i = n.n(s);

  var a =
  /*#__PURE__*/
  function () {
    function a(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      _classCallCheck(this, a);

      this.useAppToken = e, this.refreshConfig(t);
    }

    _createClass(a, [{
      key: "refreshConfig",
      value: function refreshConfig(t) {
        this._config = E.getConfig();
        var _this$_config$tokens = this._config.tokens,
            e = _this$_config$tokens.accessToken,
            n = _this$_config$tokens.app;
        this.useAppToken ? this._authorization = n : this._authorization = e || n, this._api = t, this.reconnected = !1;
      }
    }, {
      key: "call",
      value: function () {
        var _call = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(t) {
          var e, n, _n;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  t.data || (t.data = {});
                  e = {
                    method: t.method,
                    url: this._api + t.function,
                    headers: {
                      Authorization: "Bearer " + this._authorization,
                      accept: "application/json",
                      "Content-Type": "application/json"
                    },
                    data: t.data,
                    json: !0
                  };
                  _context.prev = 2;
                  _context.next = 5;
                  return i()(e);

                case 5:
                  n = _context.sent;
                  _context.next = 25;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context["catch"](2);

                  if (!_context.t0.response) {
                    _context.next = 24;
                    break;
                  }

                  _n = _context.t0.response;

                  if (!(403 === _n.status && "accessTokenExpired" === _n.data.code && !1 === this.reconnected)) {
                    _context.next = 23;
                    break;
                  }

                  _context.prev = 13;
                  _context.next = 16;
                  return this.reconnect();

                case 16:
                  this.reconnected = !0;
                  _context.next = 22;
                  break;

                case 19:
                  _context.prev = 19;
                  _context.t1 = _context["catch"](13);
                  E.on("notAuthorized");

                case 22:
                  return _context.abrupt("return", (this.refreshConfig(this._api), this.call(t)));

                case 23:
                  throw 403 === _n.status && "userNotAllowed" === _n.data.code ? E.on("userNotAllowed") : 403 === _n.status && E.on("notAuthorized"), _n ? new o(_n.data.code, _n.data.errors, _n.data.message) : (console.log(_context.t0), new r());

                case 24:
                  throw _context.t0;

                case 25:
                  return _context.abrupt("return", n.data);

                case 26:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 8], [13, 19]]);
        }));

        function call(_x) {
          return _call.apply(this, arguments);
        }

        return call;
      }()
    }, {
      key: "reconnect",
      value: function () {
        var _reconnect = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var _E$getConfig, t, e, n, o;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _E$getConfig = E.getConfig(), t = _E$getConfig.tokens, e = new c().getPool(), n = {
                    method: "POST",
                    url: "https://authentication.datenbanker.at/token/refresh",
                    headers: {
                      Authorization: "Bearer " + t.app,
                      accept: "application/json",
                      "Content-Type": "application/json"
                    },
                    data: {
                      pool: e,
                      token: t.refreshToken
                    }
                  };
                  _context2.next = 3;
                  return i()(n);

                case 3:
                  o = _context2.sent;
                  E.setTokens(o.data);
                  return _context2.abrupt("return", o.data);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function reconnect() {
          return _reconnect.apply(this, arguments);
        }

        return reconnect;
      }()
    }]);

    return a;
  }();

  var c =
  /*#__PURE__*/
  function () {
    function c() {
      var _this = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, c);

      var e, n, o;
      o = {
        add: function () {
          var _add = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee3(t, e) {
            var n,
                o,
                r,
                s,
                i,
                _args3 = arguments;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    n = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : [];
                    o = _args3.length > 3 ? _args3[3] : undefined;
                    r = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : !1;
                    s = new a(E.getEndPoints().authentication.address);
                    !1 === r && (r = _this.config.user.pool);
                    i = {
                      username: t,
                      groups: n,
                      pool: r
                    };
                    return _context3.abrupt("return", (e && (i.email = e), o && (i.person = o), s.call({
                      method: "POST",
                      function: "/user/add",
                      data: i
                    })));

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function add(_x2, _x3) {
            return _add.apply(this, arguments);
          }

          return add;
        }(),
        update: function () {
          var _update = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4(t, e) {
            var n,
                o,
                _args4 = arguments;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    n = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : !1;
                    o = new a(E.getEndPoints().authentication.address);
                    return _context4.abrupt("return", (!1 === n && (n = _this.config.user.pool), o.call({
                      method: "POST",
                      function: "/user/update",
                      data: _objectSpread({}, t, {
                        id: e,
                        pool: n
                      })
                    })));

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function update(_x4, _x5) {
            return _update.apply(this, arguments);
          }

          return update;
        }()
      }, (n = "user") in (e = this) ? Object.defineProperty(e, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[n] = o, this.config = {
        user: {
          pool: u(t.user)
        }
      };
    }

    _createClass(c, [{
      key: "login",
      value: function () {
        var _login = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(t, e) {
          var n, o;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  n = new a(E.getEndPoints().authentication.address, !0);
                  _context5.next = 3;
                  return n.call({
                    method: "POST",
                    function: "/login",
                    data: {
                      username: t,
                      password: e,
                      pool: this.config.user.pool
                    }
                  });

                case 3:
                  o = _context5.sent;
                  return _context5.abrupt("return", (o.accessToken && o.idToken && o.refreshToken && E.setTokens(_objectSpread({}, o)), o));

                case 5:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function login(_x6, _x7) {
          return _login.apply(this, arguments);
        }

        return login;
      }()
    }, {
      key: "logout",
      value: function logout() {
        E.setTokens(!1);
      }
    }, {
      key: "challenge",
      value: function () {
        var _challenge = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6(t, e) {
          var n, o;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  n = new a(E.getEndPoints().authentication.address);
                  _context6.next = 3;
                  return n.call({
                    method: "POST",
                    function: "/challenge",
                    data: {
                      session: e,
                      challenges: t
                    }
                  });

                case 3:
                  o = _context6.sent;
                  return _context6.abrupt("return", (o.accessToken && o.idToken && o.refreshToken && E.setTokens(_objectSpread({}, o)), o));

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        function challenge(_x8, _x9) {
          return _challenge.apply(this, arguments);
        }

        return challenge;
      }()
    }, {
      key: "resetPassword",
      value: function () {
        var _resetPassword = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7(t) {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", new a(E.getEndPoints().authentication.address).call({
                    method: "POST",
                    function: "/password/reset",
                    data: {
                      email: t,
                      pool: this.config.user.pool
                    }
                  }));

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function resetPassword(_x10) {
          return _resetPassword.apply(this, arguments);
        }

        return resetPassword;
      }()
    }, {
      key: "resetAccount",
      value: function () {
        var _resetAccount = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8(t) {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.abrupt("return", new a(E.getEndPoints().authentication.address).call({
                    method: "POST",
                    function: "/account/reset",
                    data: {
                      email: t,
                      pool: this.config.user.pool
                    }
                  }));

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function resetAccount(_x11) {
          return _resetAccount.apply(this, arguments);
        }

        return resetAccount;
      }()
    }, {
      key: "getPool",
      value: function getPool() {
        return this.config.user.pool;
      }
    }]);

    return c;
  }();

  var u = function u() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (t.pool) return t.pool;
    var e = E.getConfig().services.authentication;
    return e.user && e.user.pool && 1 === e.user.pool.length ? e.user.pool[0] : void 0;
  };

  function d(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var l = function l() {
    _classCallCheck(this, l);

    d(this, "pool", {
      myPools: function () {
        var _myPools = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9() {
          var t;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  t = new a(E.getEndPoints().art.address);
                  _context9.next = 3;
                  return t.call({
                    method: "GET",
                    function: "/my/pools"
                  });

                case 3:
                  return _context9.abrupt("return", _context9.sent);

                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        function myPools() {
          return _myPools.apply(this, arguments);
        }

        return myPools;
      }(),
      get: function () {
        var _get = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee10(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context10.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/pool",
                    data: {
                      id: t
                    }
                  });

                case 3:
                  return _context10.abrupt("return", _context10.sent);

                case 4:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        function get(_x12) {
          return _get.apply(this, arguments);
        }

        return get;
      }(),
      getByUser: function () {
        var _getByUser = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee11(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context11.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/users/pools",
                    data: {
                      id: t
                    }
                  });

                case 3:
                  return _context11.abrupt("return", _context11.sent);

                case 4:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        function getByUser(_x13) {
          return _getByUser.apply(this, arguments);
        }

        return getByUser;
      }(),
      all: function () {
        var _all = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12() {
          var t;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = new a(E.getEndPoints().art.address);
                  _context12.next = 3;
                  return t.call({
                    method: "GET",
                    function: "/pool/all"
                  });

                case 3:
                  return _context12.abrupt("return", _context12.sent);

                case 4:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        function all() {
          return _all.apply(this, arguments);
        }

        return all;
      }(),
      add: function () {
        var _add2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee13(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  console.log(_objectSpread({}, t));
                  e = new a(E.getEndPoints().art.address);
                  _context13.next = 4;
                  return e.call({
                    method: "POST",
                    function: "/pool/add",
                    data: _objectSpread({}, t)
                  });

                case 4:
                  return _context13.abrupt("return", _context13.sent);

                case 5:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }));

        function add(_x14) {
          return _add2.apply(this, arguments);
        }

        return add;
      }(),
      delete: function () {
        var _delete2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee14(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context14.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/pool/delete",
                    data: {
                      id: t
                    }
                  });

                case 3:
                  return _context14.abrupt("return", _context14.sent);

                case 4:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14);
        }));

        function _delete(_x15) {
          return _delete2.apply(this, arguments);
        }

        return _delete;
      }(),
      user: {
        add: function () {
          var _add3 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee15(t, e) {
            var n;
            return _regeneratorRuntime.wrap(function _callee15$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    n = new a(E.getEndPoints().art.address);
                    _context15.next = 3;
                    return n.call({
                      method: "POST",
                      function: "/pool/user/add",
                      data: {
                        pool: e,
                        user: t
                      }
                    });

                  case 3:
                    return _context15.abrupt("return", _context15.sent);

                  case 4:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee15);
          }));

          function add(_x16, _x17) {
            return _add3.apply(this, arguments);
          }

          return add;
        }(),
        delete: function () {
          var _delete3 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee16(t, e) {
            var n;
            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    n = new a(E.getEndPoints().art.address);
                    _context16.next = 3;
                    return n.call({
                      method: "POST",
                      function: "/pool/user/delete",
                      data: {
                        pool: e,
                        user: t
                      }
                    });

                  case 3:
                    return _context16.abrupt("return", _context16.sent);

                  case 4:
                  case "end":
                    return _context16.stop();
                }
              }
            }, _callee16);
          }));

          function _delete(_x18, _x19) {
            return _delete3.apply(this, arguments);
          }

          return _delete;
        }()
      },
      art: {
        add: function () {
          var _add4 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee17(t, e) {
            var n;
            return _regeneratorRuntime.wrap(function _callee17$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    n = new a(E.getEndPoints().art.address);
                    _context17.next = 3;
                    return n.call({
                      method: "POST",
                      function: "/pool/art/add",
                      data: {
                        pool: e,
                        art: t
                      }
                    });

                  case 3:
                    return _context17.abrupt("return", _context17.sent);

                  case 4:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee17);
          }));

          function add(_x20, _x21) {
            return _add4.apply(this, arguments);
          }

          return add;
        }(),
        delete: function () {
          var _delete4 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee18(t, e) {
            var n;
            return _regeneratorRuntime.wrap(function _callee18$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    n = new a(E.getEndPoints().art.address);
                    _context18.next = 3;
                    return n.call({
                      method: "POST",
                      function: "/pool/art/delete",
                      data: {
                        pool: e,
                        art: t
                      }
                    });

                  case 3:
                    return _context18.abrupt("return", _context18.sent);

                  case 4:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee18);
          }));

          function _delete(_x22, _x23) {
            return _delete4.apply(this, arguments);
          }

          return _delete;
        }()
      }
    }), d(this, "artist", {
      get: function () {
        var _get2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee19(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context19.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/artist",
                    data: {
                      id: t
                    }
                  });

                case 3:
                  return _context19.abrupt("return", _context19.sent);

                case 4:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19);
        }));

        function get(_x24) {
          return _get2.apply(this, arguments);
        }

        return get;
      }(),
      getByPerson: function () {
        var _getByPerson = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee20(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context20.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/artist",
                    data: {
                      person: t
                    }
                  });

                case 3:
                  return _context20.abrupt("return", _context20.sent);

                case 4:
                case "end":
                  return _context20.stop();
              }
            }
          }, _callee20);
        }));

        function getByPerson(_x25) {
          return _getByPerson.apply(this, arguments);
        }

        return getByPerson;
      }(),
      all: function () {
        var _all2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee21() {
          var t;
          return _regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  t = new a(E.getEndPoints().art.address);
                  _context21.next = 3;
                  return t.call({
                    method: "GET",
                    function: "/artist/all"
                  });

                case 3:
                  return _context21.abrupt("return", _context21.sent);

                case 4:
                case "end":
                  return _context21.stop();
              }
            }
          }, _callee21);
        }));

        function all() {
          return _all2.apply(this, arguments);
        }

        return all;
      }(),
      add: function () {
        var _add5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee22(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee22$(_context22) {
            while (1) {
              switch (_context22.prev = _context22.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context22.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/artist/add",
                    data: _objectSpread({}, t)
                  });

                case 3:
                  return _context22.abrupt("return", _context22.sent);

                case 4:
                case "end":
                  return _context22.stop();
              }
            }
          }, _callee22);
        }));

        function add(_x26) {
          return _add5.apply(this, arguments);
        }

        return add;
      }(),
      update: function () {
        var _update2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee23(t) {
          return _regeneratorRuntime.wrap(function _callee23$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  return _context23.abrupt("return", new a(E.getEndPoints().art.address).call({
                    method: "POST",
                    function: "/artist/update",
                    data: _objectSpread({}, t)
                  }));

                case 1:
                case "end":
                  return _context23.stop();
              }
            }
          }, _callee23);
        }));

        function update(_x27) {
          return _update2.apply(this, arguments);
        }

        return update;
      }(),
      delete: function () {
        var _delete5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee24(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context24.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/artist/delete",
                    data: {
                      id: t
                    }
                  });

                case 3:
                  return _context24.abrupt("return", _context24.sent);

                case 4:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24);
        }));

        function _delete(_x28) {
          return _delete5.apply(this, arguments);
        }

        return _delete;
      }(),
      history: function () {
        var _history = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee25() {
          var t,
              e,
              n,
              o,
              _args25 = arguments;
          return _regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  t = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : !1;
                  e = _args25.length > 1 ? _args25[1] : undefined;
                  n = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : 10;

                  if (t) {
                    _context25.next = 5;
                    break;
                  }

                  throw new IdException("Please set an id in Artist.history()");

                case 5:
                  o = new a(E.getEndPoints().art.address);
                  _context25.next = 8;
                  return o.call({
                    method: "POST",
                    function: "/artist/history",
                    data: {
                      id: t,
                      position: e || "eyJlbnRyeSI6MH0=",
                      amount: n
                    }
                  });

                case 8:
                  return _context25.abrupt("return", _context25.sent);

                case 9:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25);
        }));

        function history() {
          return _history.apply(this, arguments);
        }

        return history;
      }()
    }), d(this, "art", {
      all: function () {
        var _all3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee26(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  e = new a(E.getEndPoints().art.address);
                  _context26.next = 3;
                  return e.call({
                    method: "POST",
                    function: "/art/all",
                    data: {
                      pool: t
                    }
                  });

                case 3:
                  return _context26.abrupt("return", _context26.sent);

                case 4:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26);
        }));

        function all(_x29) {
          return _all3.apply(this, arguments);
        }

        return all;
      }()
    }), this.config = {};
  };

  function f(t) {
    this.message = t, this.name = "PoolException";
  }

  function p(t) {
    this.message = t, this.name = "IdException";
  }

  function h(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var g = function g() {
    var _this2 = this;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, g);

    return h(this, "person", {
      getAll: function () {
        var _getAll = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee27() {
          var t,
              e,
              _args27 = arguments;
          return _regeneratorRuntime.wrap(function _callee27$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  t = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : !1;
                  !1 === t && (t = _this2.config.person.pool);
                  e = new a(E.getEndPoints().customer.address);
                  _context27.next = 5;
                  return e.call({
                    method: "POST",
                    function: "/person/all",
                    data: {
                      pool: t
                    }
                  });

                case 5:
                  return _context27.abrupt("return", _context27.sent);

                case 6:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee27);
        }));

        function getAll() {
          return _getAll.apply(this, arguments);
        }

        return getAll;
      }(),
      getAllUsersForUserPool: function () {
        var _getAllUsersForUserPool = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee28(t) {
          var e,
              n,
              o,
              _args28 = arguments;
          return _regeneratorRuntime.wrap(function _callee28$(_context28) {
            while (1) {
              switch (_context28.prev = _context28.next) {
                case 0:
                  e = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : !1;
                  n = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : !1;
                  !1 === n && (n = _this2.config.person.pool), !1 === e && (e = _this2.config.user.pool);
                  o = new a(E.getEndPoints().authentication.address);
                  _context28.next = 6;
                  return o.call({
                    method: "POST",
                    function: "/user/get",
                    data: {
                      pool: e,
                      person: {
                        id: t,
                        pool: n
                      }
                    }
                  });

                case 6:
                  return _context28.abrupt("return", _context28.sent);

                case 7:
                case "end":
                  return _context28.stop();
              }
            }
          }, _callee28);
        }));

        function getAllUsersForUserPool(_x30) {
          return _getAllUsersForUserPool.apply(this, arguments);
        }

        return getAllUsersForUserPool;
      }(),
      get: function () {
        var _get3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee29(t) {
          var e,
              n,
              _args29 = arguments;
          return _regeneratorRuntime.wrap(function _callee29$(_context29) {
            while (1) {
              switch (_context29.prev = _context29.next) {
                case 0:
                  e = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : !1;
                  !1 === e && (e = _this2.config.person.pool);
                  n = new a(E.getEndPoints().customer.address);
                  _context29.next = 5;
                  return n.call({
                    method: "POST",
                    function: "/person/get",
                    data: {
                      id: t,
                      pool: e
                    }
                  });

                case 5:
                  return _context29.abrupt("return", _context29.sent);

                case 6:
                case "end":
                  return _context29.stop();
              }
            }
          }, _callee29);
        }));

        function get(_x31) {
          return _get3.apply(this, arguments);
        }

        return get;
      }(),
      add: function () {
        var _add6 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee30(t) {
          var e,
              n,
              _args30 = arguments;
          return _regeneratorRuntime.wrap(function _callee30$(_context30) {
            while (1) {
              switch (_context30.prev = _context30.next) {
                case 0:
                  e = _args30.length > 1 && _args30[1] !== undefined ? _args30[1] : !1;
                  !1 === e && (e = _this2.config.person.pool);
                  n = new a(E.getEndPoints().customer.address);
                  _context30.next = 5;
                  return n.call({
                    method: "POST",
                    function: "/person/add",
                    data: _objectSpread({
                      pool: e
                    }, t)
                  });

                case 5:
                  return _context30.abrupt("return", _context30.sent);

                case 6:
                case "end":
                  return _context30.stop();
              }
            }
          }, _callee30);
        }));

        function add(_x32) {
          return _add6.apply(this, arguments);
        }

        return add;
      }(),
      update: function () {
        var _update3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee31(t) {
          var e,
              n,
              o,
              _args31 = arguments;
          return _regeneratorRuntime.wrap(function _callee31$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  e = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : !1;
                  n = _args31.length > 2 && _args31[2] !== undefined ? _args31[2] : !1;

                  if (!(!1 === n && (n = _this2.config.person.pool), !e)) {
                    _context31.next = 4;
                    break;
                  }

                  throw new p("Please set an id in Person.update()");

                case 4:
                  o = new a(E.getEndPoints().customer.address);
                  _context31.next = 7;
                  return o.call({
                    method: "POST",
                    function: "/person/update",
                    data: _objectSpread({
                      id: e,
                      pool: n
                    }, t)
                  });

                case 7:
                  return _context31.abrupt("return", _context31.sent);

                case 8:
                case "end":
                  return _context31.stop();
              }
            }
          }, _callee31);
        }));

        function update(_x33) {
          return _update3.apply(this, arguments);
        }

        return update;
      }(),
      history: function () {
        var _history2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee32() {
          var t,
              e,
              n,
              o,
              r,
              _args32 = arguments;
          return _regeneratorRuntime.wrap(function _callee32$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  t = _args32.length > 0 && _args32[0] !== undefined ? _args32[0] : !1;
                  e = _args32.length > 1 && _args32[1] !== undefined ? _args32[1] : !1;
                  n = _args32.length > 2 ? _args32[2] : undefined;
                  o = _args32.length > 3 && _args32[3] !== undefined ? _args32[3] : 10;

                  if (!(!1 === e && (e = _this2.config.person.pool), !t)) {
                    _context32.next = 6;
                    break;
                  }

                  throw new p("Please set an id in Person.history()");

                case 6:
                  r = new a(E.getEndPoints().customer.address);
                  _context32.next = 9;
                  return r.call({
                    method: "POST",
                    function: "/person/history",
                    data: {
                      id: t,
                      pool: e,
                      position: n || "eyJlbnRyeSI6MH0=",
                      amount: o
                    }
                  });

                case 9:
                  return _context32.abrupt("return", _context32.sent);

                case 10:
                case "end":
                  return _context32.stop();
              }
            }
          }, _callee32);
        }));

        function history() {
          return _history2.apply(this, arguments);
        }

        return history;
      }(),
      delete: function () {
        var _delete6 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee33(t) {
          var e,
              n,
              _args33 = arguments;
          return _regeneratorRuntime.wrap(function _callee33$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  e = _args33.length > 1 && _args33[1] !== undefined ? _args33[1] : !1;
                  !1 === e && (e = _this2.config.person.pool);
                  n = new a(E.getEndPoints().customer.address);
                  _context33.next = 5;
                  return n.call({
                    method: "POST",
                    function: "/person/delete",
                    data: {
                      pool: e,
                      id: t
                    }
                  });

                case 5:
                  return _context33.abrupt("return", _context33.sent);

                case 6:
                case "end":
                  return _context33.stop();
              }
            }
          }, _callee33);
        }));

        function _delete(_x34) {
          return _delete6.apply(this, arguments);
        }

        return _delete;
      }(),
      getAllTaskClocks: function () {
        var _getAllTaskClocks = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee34() {
          var t,
              e,
              n,
              _args34 = arguments;
          return _regeneratorRuntime.wrap(function _callee34$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  t = _args34.length > 0 && _args34[0] !== undefined ? _args34[0] : !1;
                  e = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : !1;

                  if (!(!1 === e && (e = _this2.config.task.pool), !t)) {
                    _context34.next = 4;
                    break;
                  }

                  throw new p("Please set an id in Person.getAllTaskClocks()");

                case 4:
                  n = new a(E.getEndPoints().customer.address);
                  _context34.next = 7;
                  return n.call({
                    method: "POST",
                    function: "/person/task/timeclock/all",
                    data: {
                      id: t,
                      pool: e
                    }
                  });

                case 7:
                  return _context34.abrupt("return", _context34.sent);

                case 8:
                case "end":
                  return _context34.stop();
              }
            }
          }, _callee34);
        }));

        function getAllTaskClocks() {
          return _getAllTaskClocks.apply(this, arguments);
        }

        return getAllTaskClocks;
      }()
    }), h(this, "opportunity", {
      getAll: function () {
        var _getAll2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee35() {
          var t,
              e,
              _args35 = arguments;
          return _regeneratorRuntime.wrap(function _callee35$(_context35) {
            while (1) {
              switch (_context35.prev = _context35.next) {
                case 0:
                  t = _args35.length > 0 && _args35[0] !== undefined ? _args35[0] : !1;
                  !1 === t && (t = _this2.config.opportunity.pool);
                  e = new a(E.getEndPoints().customer.address);
                  _context35.next = 5;
                  return e.call({
                    method: "POST",
                    function: "/opportunity/all",
                    data: {
                      pool: t
                    }
                  });

                case 5:
                  return _context35.abrupt("return", _context35.sent);

                case 6:
                case "end":
                  return _context35.stop();
              }
            }
          }, _callee35);
        }));

        function getAll() {
          return _getAll2.apply(this, arguments);
        }

        return getAll;
      }(),
      get: function () {
        var _get4 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee36(t) {
          var e,
              n,
              _args36 = arguments;
          return _regeneratorRuntime.wrap(function _callee36$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  e = _args36.length > 1 && _args36[1] !== undefined ? _args36[1] : !1;

                  if (!(!1 === e && (e = _this2.config.opportunity.pool), !t)) {
                    _context36.next = 3;
                    break;
                  }

                  throw new p("Please set an id in Opportunity.get()");

                case 3:
                  n = new a(E.getEndPoints().customer.address);
                  _context36.next = 6;
                  return n.call({
                    method: "POST",
                    function: "/opportunity/get",
                    data: {
                      id: t,
                      pool: e
                    }
                  });

                case 6:
                  return _context36.abrupt("return", _context36.sent);

                case 7:
                case "end":
                  return _context36.stop();
              }
            }
          }, _callee36);
        }));

        function get(_x35) {
          return _get4.apply(this, arguments);
        }

        return get;
      }(),
      add: function () {
        var _add7 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee37(t) {
          var e,
              n,
              _args37 = arguments;
          return _regeneratorRuntime.wrap(function _callee37$(_context37) {
            while (1) {
              switch (_context37.prev = _context37.next) {
                case 0:
                  e = _args37.length > 1 && _args37[1] !== undefined ? _args37[1] : !1;
                  !1 === e && (e = _this2.config.opportunity.pool);
                  n = new a(E.getEndPoints().customer.address);
                  _context37.next = 5;
                  return n.call({
                    method: "POST",
                    function: "/opportunity/add",
                    data: _objectSpread({
                      pool: e
                    }, t)
                  });

                case 5:
                  return _context37.abrupt("return", _context37.sent);

                case 6:
                case "end":
                  return _context37.stop();
              }
            }
          }, _callee37);
        }));

        function add(_x36) {
          return _add7.apply(this, arguments);
        }

        return add;
      }(),
      update: function () {
        var _update4 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee38(t, e) {
          var n,
              o,
              _args38 = arguments;
          return _regeneratorRuntime.wrap(function _callee38$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  n = _args38.length > 2 && _args38[2] !== undefined ? _args38[2] : !1;

                  if (!(!1 === n && (n = _this2.config.opportunity.pool), !e)) {
                    _context38.next = 3;
                    break;
                  }

                  throw new p("Please set an id in Opportunity.update()");

                case 3:
                  t.persons && t.persons.map(function (t) {
                    return t.pool || (t.pool = _this2.config.person.pool), t;
                  });
                  o = new a(E.getEndPoints().customer.address);
                  _context38.next = 7;
                  return o.call({
                    method: "POST",
                    function: "/opportunity/update",
                    data: _objectSpread({
                      id: e,
                      pool: n
                    }, t)
                  });

                case 7:
                  return _context38.abrupt("return", _context38.sent);

                case 8:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee38);
        }));

        function update(_x37, _x38) {
          return _update4.apply(this, arguments);
        }

        return update;
      }(),
      delete: function () {
        var _delete7 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee39(t) {
          var e,
              n,
              _args39 = arguments;
          return _regeneratorRuntime.wrap(function _callee39$(_context39) {
            while (1) {
              switch (_context39.prev = _context39.next) {
                case 0:
                  e = _args39.length > 1 && _args39[1] !== undefined ? _args39[1] : !1;

                  if (!(!1 === e && (e = _this2.config.opportunity.pool), !t)) {
                    _context39.next = 3;
                    break;
                  }

                  throw new p("Please set an id for Person.delete()");

                case 3:
                  n = new a(E.getEndPoints().customer.address);
                  _context39.next = 6;
                  return n.call({
                    method: "POST",
                    function: "/opportunity/delete",
                    data: {
                      id: t,
                      pool: e
                    }
                  });

                case 6:
                  return _context39.abrupt("return", _context39.sent);

                case 7:
                case "end":
                  return _context39.stop();
              }
            }
          }, _callee39);
        }));

        function _delete(_x39) {
          return _delete7.apply(this, arguments);
        }

        return _delete;
      }(),
      getPool: function () {
        var _getPool = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee40() {
          var t,
              e,
              _args40 = arguments;
          return _regeneratorRuntime.wrap(function _callee40$(_context40) {
            while (1) {
              switch (_context40.prev = _context40.next) {
                case 0:
                  t = _args40.length > 0 && _args40[0] !== undefined ? _args40[0] : !1;

                  if (!(!1 === t && (t = _this2.config.opportunity.pool), !t)) {
                    _context40.next = 3;
                    break;
                  }

                  throw new p("Please set an id in Opportunity.getPool()");

                case 3:
                  e = new a(E.getEndPoints().customer.address);
                  _context40.next = 6;
                  return e.call({
                    method: "POST",
                    function: "/opportunity/pool/get",
                    data: {
                      id: t
                    }
                  });

                case 6:
                  return _context40.abrupt("return", _context40.sent);

                case 7:
                case "end":
                  return _context40.stop();
              }
            }
          }, _callee40);
        }));

        function getPool() {
          return _getPool.apply(this, arguments);
        }

        return getPool;
      }()
    }), h(this, "task", {
      timeClock: {
        add: function () {
          var _add8 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee41(t, e) {
            var n,
                o,
                r,
                _args41 = arguments;
            return _regeneratorRuntime.wrap(function _callee41$(_context41) {
              while (1) {
                switch (_context41.prev = _context41.next) {
                  case 0:
                    n = _args41.length > 2 && _args41[2] !== undefined ? _args41[2] : [];
                    o = _args41.length > 3 && _args41[3] !== undefined ? _args41[3] : !1;
                    !1 === o && (o = _this2.config.task.pool);
                    r = new a(E.getEndPoints().customer.address);
                    _context41.next = 6;
                    return r.call({
                      method: "POST",
                      function: "/task/timeclock/add",
                      data: {
                        pool: o,
                        start: t,
                        end: e,
                        pauses: n
                      }
                    });

                  case 6:
                    return _context41.abrupt("return", _context41.sent);

                  case 7:
                  case "end":
                    return _context41.stop();
                }
              }
            }, _callee41);
          }));

          function add(_x40, _x41) {
            return _add8.apply(this, arguments);
          }

          return add;
        }()
      }
    }), this.config = {
      person: {
        pool: m(t.person)
      },
      opportunity: {
        pool: w(t.opportunity)
      },
      task: {
        pool: y(t.task)
      },
      user: {
        pool: P(t.user)
      }
    }, {
      person: this.person,
      opportunity: this.opportunity,
      task: this.task
    };
  };

  var m = function m() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (t.pool) return t.pool;
    var e = E.getConfig().services.customer;
    if (e.person && e.person.pool && 1 === e.person.pool.length) return e.person.pool[0];
    throw new f("Person pool could not be identified!");
  },
      w = function w() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (t.pool) return t.pool;
    var e = E.getConfig().services.customer;
    if (e.opportunity && e.opportunity.pool && 1 === e.opportunity.pool.length) return e.opportunity.pool[0];
    throw new f("Opportunity pool could not be identified!");
  },
      y = function y() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (t.pool) return t.pool;
    var e = E.getConfig().services.customer;
    if (e.task && e.task.pool && 1 === e.task.pool.length) return e.task.pool[0];
    throw new f("Task pool could not be identified!");
  },
      P = function P() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (t.pool) return t.pool;
    var e = E.getConfig().services.authentication;
    if (e.user && e.user.pool && 1 === e.user.pool.length) return e.user.pool[0];
    throw new f("Authentication pool could not be identified!");
  };

  var T = {
    access: {
      address: "https://access.datenbanker.at"
    },
    authentication: {
      address: "https://authentication.datenbanker.at"
    },
    customer: {
      address: "https://customer.datenbanker.at"
    },
    art: {
      address: "https://art.datenbanker.at"
    }
  },
      v = {
    set: function set(t, e) {
      window.localStorage.setItem(t, e);
    },
    get: function get(t) {
      return window.localStorage.getItem(t);
    },
    delete: function _delete(t) {
      return window.localStorage.removeItem(t);
    }
  };
  var k = new (
  /*#__PURE__*/
  function () {
    function _class() {
      _classCallCheck(this, _class);

      if (window.localStorage) return v;
      throw "Local Storage not supported!";
    }

    return _class;
  }())();
  var E = new (
  /*#__PURE__*/
  function () {
    function _class2() {
      _classCallCheck(this, _class2);
    }

    _createClass(_class2, [{
      key: "init",
      value: function init(t) {
        if (!t.apiToken) throw function (t) {
          this.message = t, this.name = "apiTokenNotSet";
        }("Please set an apiToken");
        var e = {
          tokens: {
            app: t.apiToken,
            accessToken: !1,
            refreshToken: !1,
            idToken: !1
          },
          groups: [],
          signedIn: !1,
          services: t.services || {},
          endPoints: t.endPoints || T,
          handler: t.handler || {},
          handlerList: ["tokenChange", "notAuthorized"]
        };
        this.config = e;
      }
    }, {
      key: "changeAppToken",
      value: function changeAppToken(t) {
        this.config.tokens.app = t;
      }
    }, {
      key: "registerHandler",
      value: function registerHandler(t) {
        this.config.handler = _objectSpread({}, this.config.handler, t);
      }
    }, {
      key: "on",
      value: function on(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.config.handler[t] && this.config.handler[t](e);
      }
    }, {
      key: "setTokens",
      value: function setTokens() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

        if (!1 === t && (t = {
          accessToken: !1,
          refreshToken: !1,
          idToken: !1
        }), t.accessToken) {
          var _e = JSON.parse(window.atob(t.accessToken.split(".")[1]));

          this.config.groups = _e.scopes;
        } else this.config.groups = [];

        k.set("user:accessToken", t.accessToken), k.set("user:idToken", t.idToken), k.set("user:refreshToken", t.refreshToken), this.on("tokenChange", t), this.config.tokens = _objectSpread({}, this.config.tokens, t), this.config.signedIn = !!t.accessToken;
      }
    }, {
      key: "getIdToken",
      value: function getIdToken() {
        return this.config.tokens.idToken;
      }
    }, {
      key: "getGroups",
      value: function getGroups() {
        return this.config.groups;
      }
    }, {
      key: "getConfig",
      value: function getConfig() {
        return this.config;
      }
    }, {
      key: "getEndPoints",
      value: function getEndPoints() {
        return this.config.endPoints;
      }
    }]);

    return _class2;
  }())();
  n.d(e, "Authentication", function () {
    return c;
  }), n.d(e, "Art", function () {
    return l;
  }), n.d(e, "Customer", function () {
    return g;
  }), n.d(e, "DevCloud", function () {
    return E;
  }), n.d(e, "Connector", function () {
    return a;
  });
}]);

export var Authentication = LIB.Authentication;
export var Art = LIB.Art;
export var Customer = LIB.Customer;
export var DevCloud = LIB.DevCloud;
export var Connector = LIB.Connector;